export interface SqlUpdateBuilder {
  setClauses: string[];
  params: unknown[];
}

export interface SqlUpdateStatement {
  sql: string;
  params: unknown[];
}

export function createSqlUpdateBuilder(): SqlUpdateBuilder {
  return {
    setClauses: [],
    params: [],
  };
}

export function addSqlUpdate(
  builder: SqlUpdateBuilder,
  columnName: string,
  value: unknown
): void {
  builder.setClauses.push(`${columnName} = ?`);
  builder.params.push(value);
}

export function addDefinedSqlUpdate<T>(
  builder: SqlUpdateBuilder,
  columnName: string,
  value: T | undefined,
  transformValue: (value: T) => unknown = (definedValue) => definedValue
): void {
  if (value === undefined) {
    return;
  }

  addSqlUpdate(builder, columnName, transformValue(value));
}

export function hasSqlUpdateAssignments(builder: SqlUpdateBuilder): boolean {
  return builder.setClauses.length > 0;
}

export function buildSqlUpdate(
  tableName: string,
  builder: SqlUpdateBuilder,
  whereClause: string,
  whereParams: unknown[]
): SqlUpdateStatement | null {
  if (!hasSqlUpdateAssignments(builder)) {
    return null;
  }

  return {
    sql: `UPDATE ${tableName} SET ${builder.setClauses.join(', ')} WHERE ${whereClause}`,
    params: [...builder.params, ...whereParams],
  };
}
